<div class="container-fluid">
  <div class="row">
    <div id="caption-container" class="col-md">
      @if (title) {
        <label id="caption">{{ title }}</label>
      }
    </div>
  </div>
</div>
